import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  Charsets_getInstancezrqwjk0yrlyw as Charsets_getInstance,
  get_name2f11g4r0d5pxp as get_name,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/charsets/Charset.js.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Phases_getInstance1dciif7svdqxc as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  isSuspendFunction153vlp5l2npj9 as isSuspendFunction,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { toList2zksu85ukrmi as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Maps.mjs';
import {
  sortedWith2csnbbb21k0lg as sortedWith,
  firstOrNull1982767dljvdy as firstOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  Text_getInstance2n0fbbag7eq4k as Text_getInstance,
  charset1dribv3ku48b1 as charset,
  withCharset27k3t3dvzhi4n as withCharset,
} from '../../../../../ktor-ktor-http/io/ktor/http/ContentTypes.mjs';
import { get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/Logger.web.mjs';
import { TextContent1rb6ftlpvl1d2 as TextContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/TextContent.mjs';
import {
  charset3qqtyytkmxogi as charset_0,
  contentType2zzm38yxo3syt as contentType,
} from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { readText27783kyxjxi1g as readText } from '../../../../../ktor-ktor-io/io/ktor/utils/io/core/Strings.nonJvm.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { readBuffery45c0omfxhxc as readBuffer } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_HttpPlainText_kt__iy89z1();
  return LOGGER;
}
var LOGGER;
function get_HttpPlainText() {
  _init_properties_HttpPlainText_kt__iy89z1();
  return HttpPlainText;
}
var HttpPlainText;
var HttpPlainTextConfigClass;
function HttpPlainTextConfig() {
  if (HttpPlainTextConfigClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableSetOf' call
        tmp.o5s_1 = LinkedHashSet().s2();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.p5s_1 = LinkedHashMap().fc();
        this.q5s_1 = null;
        this.r5s_1 = Charsets_getInstance().e4p_1;
      }
    }
    initMetadataForClass($, 'HttpPlainTextConfig', HttpPlainTextConfig);
    HttpPlainTextConfigClass = $;
  }
  return HttpPlainTextConfigClass;
}
function RenderRequestHook$install$slambda($handler) {
  return constructCallableReference(($this$intercept, content, $completion) => orPromise($completion, function *($completion) {
    var result = yield* $($handler($this$intercept.w4v_1, content, $completion), $completion);
    var tmp;
    if (!(result == null)) {
      yield* $this$intercept.y4u(result, $completion);
      tmp = Unit_instance;
    }
    return Unit_instance;
  }), 2);
}
var RenderRequestHookClass;
function RenderRequestHook() {
  if (RenderRequestHookClass === VOID) {
    class $ {
      s5s(client, handler) {
        var tmp = Phases_getInstance().s5p_1;
        client.n5j_1.a4w(tmp, RenderRequestHook$install$slambda(handler));
      }
      u5p(client, handler) {
        return this.s5s(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'RenderRequestHook');
    RenderRequestHookClass = $;
  }
  return RenderRequestHookClass;
}
var RenderRequestHook_instance;
function RenderRequestHook_getInstance() {
  return RenderRequestHook_instance;
}
function HttpPlainTextConfig$_init_$ref_isjudo() {
  return constructCallableReference(() => new (HttpPlainTextConfig())(), 0, 0, 219, '<init>');
}
function HttpPlainText$lambda($this$createClientPlugin) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.collections.sortedByDescending' call
  var this_0 = toList($this$createClientPlugin.b5q_1.p5s_1);
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp = HttpPlainText$lambda$lambda;
  var tmp$ret$1 = new (sam$kotlin_Comparator$0())(tmp);
  var withQuality = sortedWith(this_0, tmp$ret$1);
  var responseCharsetFallback = $this$createClientPlugin.b5q_1.r5s_1;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this$createClientPlugin.b5q_1.o5s_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (!$this$createClientPlugin.b5q_1.p5s_1.t4(element)) {
      destination.j2(element);
    }
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = HttpPlainText$lambda$lambda_0;
  var tmp$ret$6 = new (sam$kotlin_Comparator$0())(tmp_0);
  var withoutQuality = sortedWith(destination, tmp$ret$6);
  var tmp_1;
  var tmp0_0 = $this$createClientPlugin.b5q_1.o5s_1;
  var tmp$ret$7;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp_2;
    if (isInterface(tmp0_0, Collection())) {
      tmp_2 = tmp0_0.n1();
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp$ret$7 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s_0 = tmp0_0.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      if (!element_0.equals(Charsets_getInstance().e4p_1)) {
        tmp$ret$7 = true;
        break $l$block_0;
      }
    }
    tmp$ret$7 = false;
  }
  if (tmp$ret$7) {
    tmp_1 = true;
  } else {
    var tmp0_1 = $this$createClientPlugin.b5q_1.p5s_1.w4();
    var tmp$ret$9;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp_3;
      if (isInterface(tmp0_1, Collection())) {
        tmp_3 = tmp0_1.n1();
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp$ret$9 = false;
        break $l$block_2;
      }
      var _iterator__ex2g4s_1 = tmp0_1.p1();
      while (_iterator__ex2g4s_1.q1()) {
        var element_1 = _iterator__ex2g4s_1.r1();
        if (!element_1.equals(Charsets_getInstance().e4p_1)) {
          tmp$ret$9 = true;
          break $l$block_2;
        }
      }
      tmp$ret$9 = false;
    }
    tmp_1 = tmp$ret$9;
  }
  var hasRegisteredCharsets = tmp_1;
  var tmp_4;
  if (hasRegisteredCharsets) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_1 = StringBuilder().l1();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_2 = withoutQuality.p1();
    while (_iterator__ex2g4s_2.q1()) {
      var element_2 = _iterator__ex2g4s_2.r1();
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(this_1) > 0) {
        this_1.m1(',');
      }
      this_1.m1(get_name(element_2));
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_3 = withQuality.p1();
    while (_iterator__ex2g4s_3.q1()) {
      var element_3 = _iterator__ex2g4s_3.r1();
      var charset = element_3.df();
      var quality = element_3.ef();
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(this_1) > 0) {
        this_1.m1(',');
      }
      // Inline function 'kotlin.check' call
      if (!(0.0 <= quality ? quality <= 1.0 : false)) {
        throw IllegalStateException().o('Check failed.');
      }
      // Inline function 'kotlin.math.roundToInt' call
      var this_2 = 100 * quality;
      var truncatedQuality = roundToInt(this_2) / 100.0;
      this_1.m1(get_name(charset) + ';q=' + truncatedQuality);
    }
    tmp_4 = this_1.toString();
  } else {
    tmp_4 = null;
  }
  var acceptCharsetHeader = tmp_4;
  var tmp0_elvis_lhs = $this$createClientPlugin.b5q_1.q5s_1;
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? firstOrNull(withoutQuality) : tmp0_elvis_lhs;
  var tmp_5;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = firstOrNull(withQuality);
    tmp_5 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.bf_1;
  } else {
    tmp_5 = tmp1_elvis_lhs;
  }
  var tmp3_elvis_lhs = tmp_5;
  var requestCharset = tmp3_elvis_lhs == null ? Charsets_getInstance().e4p_1 : tmp3_elvis_lhs;
  var tmp_6 = RenderRequestHook_instance;
  $this$createClientPlugin.e5q(tmp_6, HttpPlainText$lambda$slambda(acceptCharsetHeader, requestCharset));
  $this$createClientPlugin.t5s(HttpPlainText$lambda$slambda_0(responseCharsetFallback));
  return Unit_instance;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.u5s_1 = function_0;
      }
      nh(a, b) {
        return this.u5s_1(a, b);
      }
      compare(a, b) {
        return this.nh(a, b);
      }
      j5() {
        return this.u5s_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.j5(), other.j5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.j5());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function HttpPlainText$lambda$lambda(a, b) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.cf_1;
  var tmp$ret$2 = a.cf_1;
  return compareValues(tmp, tmp$ret$2);
}
function HttpPlainText$lambda$lambda_0(a, b) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = get_name(a);
  var tmp$ret$2 = get_name(b);
  return compareValues(tmp, tmp$ret$2);
}
function invoke$wrapContent(requestCharset, request, content, requestContentType) {
  var contentType = requestContentType == null ? Text_getInstance().q4z_1 : requestContentType;
  var tmp2_elvis_lhs = requestContentType == null ? null : charset(requestContentType);
  var charset_0 = tmp2_elvis_lhs == null ? requestCharset : tmp2_elvis_lhs;
  // Inline function 'io.ktor.util.logging.trace' call
  var this_0 = get_LOGGER();
  if (get_isTraceEnabled(this_0)) {
    var tmp$ret$1 = 'Sending request body to ' + request.h5l_1.toString() + ' as text/plain with charset ' + charset_0.toString();
    this_0.b4x(tmp$ret$1);
  }
  return new (TextContent())(content, withCharset(contentType, charset_0));
}
function invoke$read(responseCharsetFallback, call, body) {
  var tmp0_elvis_lhs = charset_0(call.a5k());
  var actualCharset = tmp0_elvis_lhs == null ? responseCharsetFallback : tmp0_elvis_lhs;
  // Inline function 'io.ktor.util.logging.trace' call
  var this_0 = get_LOGGER();
  if (get_isTraceEnabled(this_0)) {
    var tmp$ret$1 = 'Reading response body for ' + call.y5l().h5m().toString() + ' as String with charset ' + actualCharset.toString();
    this_0.b4x(tmp$ret$1);
  }
  return readText(body, actualCharset);
}
function invoke$addAcceptCharsetHeader(_this__u8e3s4, value) {
  if (value == null || !(_this__u8e3s4.j5l_1.t2q('Accept-Charset') == null))
    return Unit_instance;
  // Inline function 'io.ktor.util.logging.trace' call
  var this_0 = get_LOGGER();
  if (get_isTraceEnabled(this_0)) {
    var tmp$ret$1 = 'Adding Accept-Charset=' + value + ' to ' + _this__u8e3s4.h5l_1.toString();
    this_0.b4x(tmp$ret$1);
  }
  _this__u8e3s4.j5l_1.u4s('Accept-Charset', value);
}
function HttpPlainText$lambda$slambda($acceptCharsetHeader, $requestCharset) {
  return constructCallableReference((request, content, $completion) => orPromise($completion, function *($completion) {
    invoke$addAcceptCharsetHeader(request, $acceptCharsetHeader);
    var tmp;
    if (!(typeof content === 'string')) {
      return null;
    }
    var contentType_0 = contentType(request);
    var tmp_0;
    if (!(contentType_0 == null) && !(contentType_0.x4x_1 === Text_getInstance().q4z_1.x4x_1)) {
      return null;
    }
    return invoke$wrapContent($requestCharset, request, content, contentType_0);
  }), 2);
}
function HttpPlainText$lambda$slambda_0($responseCharsetFallback) {
  return constructCallableReference(($this$transformResponseBody, response, content, requestedType, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    if (!requestedType.o4w_1.equals(PrimitiveClasses_getInstance().gg())) {
      return null;
    }
    var bodyBytes = yield* readBuffer(content, $completion);
    return invoke$read($responseCharsetFallback, response.f5m(), bodyBytes);
  }), 4);
}
var properties_initialized_HttpPlainText_kt_2nx4ox;
function _init_properties_HttpPlainText_kt__iy89z1() {
  if (!properties_initialized_HttpPlainText_kt_2nx4ox) {
    properties_initialized_HttpPlainText_kt_2nx4ox = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpPlainText');
    var tmp = HttpPlainTextConfig$_init_$ref_isjudo();
    HttpPlainText = createClientPlugin('HttpPlainText', tmp, HttpPlainText$lambda);
  }
}
//region block: init
RenderRequestHook_instance = new (RenderRequestHook())();
//endregion
//region block: exports
export {
  get_HttpPlainText as get_HttpPlainText2hd9sygnz4kij,
};
//endregion

//# sourceMappingURL=HttpPlainText.mjs.map
